import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@nodus/ui";
import { createFileRoute, Outlet, redirect, useNavigate } from "@tanstack/react-router";
import * as React from "react";
import { useAuth } from "../../auth/auth-context";

// Everything under this layout needs a session; the session is the Supabase JWT (ADR-066).
export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ context, location }) => {
    const session = await context.auth.getSession();
    if (!session) throw redirect({ to: "/sign-in", search: { redirect: location.href } });
    return { session };
  },
  component: Authed,
});

/**
 * When the session ends under an open page (revoked, signed out in another tab), a modal keeps the page and any
 * draft underneath; signing in as a different user clears the cache and reloads to their last org (ui-spec §4.18).
 */
function Authed() {
  const { session, ready } = useAuth();
  const navigate = useNavigate();
  const first = React.useRef(session?.user.id);
  React.useEffect(() => {
    if (session && first.current && session.user.id !== first.current) window.location.assign("/");
    if (session) first.current = session.user.id;
  }, [session]);
  const lost = ready && !session;
  return (
    <>
      <Outlet />
      <Dialog open={lost}>
        <DialogContent hideClose onEscapeKeyDown={(e) => e.preventDefault()} onPointerDownOutside={(e) => e.preventDefault()}>
          <DialogHeader>
            <DialogTitle>Sign in again to continue</DialogTitle>
            <DialogDescription>Your session ended. Your page and drafts stay here.</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button onClick={() => navigate({ to: "/sign-in", search: { redirect: window.location.pathname + window.location.search } })}>
              Sign in
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
